import type { Router, RouteRecordRaw } from 'vue-router';

import { getToken, getFPLToken } from '@/utils/auth';
import { useUserStore } from '@/store/modules/user';
import { usePermissionStoreWidthOut } from '@/store/modules/permission';

const whiteList = ['/login'];

// 登陆页面路由 path
const LOGIN_PAGE_PATH = '/login';

export function createPermissionGuard(router: Router) {
  // 跳转之前
  router.beforeEach(async (to, from, next) => {
    const permissionStore = usePermissionStoreWidthOut();
    const userStore = useUserStore();
    // Jump to the 404 page after processing the login
    if (from.path === 'login' && to.name === 'ErrorPage') {
      next('Home');
      return;
    }

    const token = getToken();
    const fplToken = getFPLToken();
    if (!token || !fplToken) {
      // 没有token
      if (whiteList.indexOf(to.path) !== -1) {
        // 白名单
        next();
        return;
      }

      try {
        await userStore.get4PLTokenWithOAToken();
        next({ ...to, replace: true });
        return;
      } catch (error) {
        console.warn('获取4PL token失败', error);
        next({ path: LOGIN_PAGE_PATH });
        return;
      }
    } else {
      if (permissionStore.getIsDynamicAddedRoute) {
        next();
        return;
      }
      // 判断token是否过期
      await userStore.getPermission();
      // 构建路由
      const routes = await permissionStore.buildRoutesAction();
      routes.forEach((route) => {
        router.addRoute(route as unknown as RouteRecordRaw);
      });
      permissionStore.setDynamicAddedRoute(true);

      // if (to.path === LOGIN_PAGE_PATH) {
      //   if (to.query && to.query.redirectUrl) {
      //     if (to.query.redirectUrl.includes('ods')) {
      //       window.location.href = `${process.env.VUE_APP_ODS_SERVERS_URL}`;
      //     } else if (to.query.redirectUrl.includes('tms')) {
      //       window.location.href = `${process.env.VUE_APP_TMS_SERVERS_URL}`;
      //     } else if (to.query.redirectUrl.includes('fpl')) {
      //       window.location.href = `${process.env.VUE_APP_FPL_SERVERS_URL}`;
      //     }
      //   } else {
      //     next({ path: '/' });
      //   }
      // } else {
      next({
        path: to.path,
        query: to.query,
      });
      // }
    }
  });
}
